import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './roomTypeMultiSelect.scss';
import { hotelApi } from '../../../services/apis';
import { Checkbox } from '../../../component';
import { ChevronDownIcon } from '../../../content/svg-component';
import { Conditional } from '../../../utils/utility';
const RoomTypeMultiSelect = ({
  isHotelChanged = false,
  intl = {},
  language = { name: 'en', direction: 'ltr' },
  hotel = {},
  value = { data: [], totalRooms: 0 },
  onSelectRoom = () => {},
  setIsHotelChanged = () => {},
}) => {
  const outSideClick = useRef(null);
  const [isListOpen, setIsListOpen] = useState(false);
  const [selectedRooms, setSelectedRooms] = useState({});
  const [roomsList, setRoomsList] = useState([]);
  const [filteredRoomsList, setFilteredRoomsList] = useState([]);
  const [searchRoomType, setSearchRoomType] = useState('');

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    let initialSelectedRooms = {};
    if (value?.totalRooms !== 0) {
      const data = roomsList.map((room) => {
        const itemValue = value?.data?.find(
          (itemValue) => itemValue.name === room.name,
        );
        return itemValue
          ? itemValue
          : { name: room?.name, count: 0, extraBeds: false };
      });
      initialSelectedRooms = { data, totalRooms: value?.totalRooms };
    } else {
      initialSelectedRooms = {
        data: roomsList?.map(({ name }, index) => {
          return { name, count: 0, extraBeds: false };
        }),
        totalRooms: 0,
      };
    }
    setSelectedRooms(initialSelectedRooms);
  }, [roomsList]);
  useEffect(() => {
    if (hotel?.eghamat24_id) fetchRoomsList();
  }, [hotel]);
  useEffect(() => {
    if (isHotelChanged) {
      setSelectedRooms({});
      onSelectRoom({});
      setIsHotelChanged(false);
    }
  }, [isHotelChanged]);

  const fetchRoomsList = async () => {
    try {
      let {
        payload: { data },
      } = await hotelApi?.getRooms({ hotelId: hotel?.eghamat24_id });
      data = data?.map((object) => {
        return {
          ...object,
          name: { fa: object?.name, en: object?.name },
          id: object?.id,
        };
      });
      setRoomsList(data);
      setFilteredRoomsList(data);
    } catch ({ message }) {
      setToastify({ type: 'danger', message });
    }
  };

  const handleClickOutside = (event) => {
    if (outSideClick.current && !outSideClick.current.contains(event.target)) {
      setIsListOpen(false);
    }
  };

  const handleExtraBedsCheck = (room) => {
    const { name } = room;
    const updateData = selectedRooms?.data?.map((item) => {
      if (name[language.name] === item?.name[language.name]) {
        return { ...item, extraBeds: !item?.extraBeds };
      } else return item;
    });
    setSelectedRooms((prevState) => {
      return { ...prevState, data: updateData };
    });
  };

  const handleRoomsCountChange = (event, room) => {
    let { value } = event?.target;
    const { name } = room;
    const updateData = selectedRooms?.data?.map((item) => {
      if (name === item?.name) {
        return { ...item, count: +value };
      } else return item;
    });
    const totalRooms = calcTotalRooms(updateData);
    setSelectedRooms({ data: updateData, totalRooms });
    onSelectRoom({
      ...selectedRooms,
      data: selectedRooms?.data?.filter((room) => room?.count !== 0),
    });
  };

  const handleSearchRoom = ({ target }) => {
    const { value } = target;
    const updatedData = roomsList?.filter((room) =>
      room?.name?.includes(value),
    );
    setFilteredRoomsList(updatedData);
    setSearchRoomType(value);
  };

  const calcTotalRooms = (roomData) => {
    const totalRooms = roomData?.reduce((sum, { count }) => {
      return +sum + +count;
    }, 0);
    return totalRooms;
  };
  const generateSelectedRoomsString = () => {
    const roomNames = selectedRooms?.data?.filter(({ count }) => count !== 0);
    return roomNames?.map(({ name }) => name?.[language.name])?.join(' , ');
  };

  return (
    <div className="room-type-multi-select w-100 d-flex flex-column align-items-center">
      <label className="px-3 pb-2 text-start text-dark w-100 m-0">
        {intl.formatMessage({ id: 'booking.roomtype' })}
      </label>
      <div className="w-100 position-relative" ref={outSideClick}>
        <div
          className={`w-100 heightResponsive d-flex align-items-center justify-content-between bg-third-light cursor-pointer border-default ${
            isListOpen ? 'rounded-default-top' : 'rounded-default'
          }`}
          onClick={() => setIsListOpen((prevState) => !prevState)}
        >
          <span className="col-11 d-flex align-items-center text-dark px-2 py-0 my-2">
            {selectedRooms?.totalRooms && !isListOpen ? (
              <span className="w-100 text-start text-truncate text-nowrap">
                {generateSelectedRoomsString()}
              </span>
            ) : (
              <input
                className="w-100 border-0 text-muted bg-transparent"
                placeholder={intl?.formatMessage({ id: 'booking.search' })}
                value={searchRoomType}
                onClick={(event) => {
                  event?.stopPropagation();
                  setIsListOpen(true);
                }}
                onChange={handleSearchRoom}
              />
            )}
          </span>
          <span
            className={`col-1 d-flex align-items-center justify-content-center p-0 transition-all ${
              isListOpen ? 'rotate-icon' : ''
            }`}
          >
            <ChevronDownIcon color="#aaacaf" size={18} />
          </span>
        </div>
        {isListOpen && (
          <ul className="w-100 position-absolute d-flex flex-column m-0 p-0 list-unstyled border-default rounded-default-bottom zIndex-list bg-third-light shadow-sm list-container font-xsmall">
            {filteredRoomsList?.map((item, index) => {
              const roomItemValue = selectedRooms?.data?.find(({ name }) => {
                return name.en === item?.name.en;
              });
              return (
                <li
                  key={item?.id}
                  id={item?.id}
                  className={`w-100 d-flex align-items-center justify-content-between p-3 ${
                    index !== filteredRoomsList?.length - 1
                      ? 'border-bottom'
                      : ''
                  }
                  ${roomItemValue?.count !== 0 ? 'bg-gray' : ''}`}
                >
                  <div className="col-4 d-flex align-items-center text-truncate text-nowrap p-0">
                    {item?.name?.[language?.name]}
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-between p-0">
                    <span className="col-6 px-1 text-end">
                      {intl.formatMessage({ id: 'booking.count' })}
                    </span>
                    <span className="col-6 px-1 d-flex align-items-center justify-content-center">
                      <input
                        className="w-100 bg-transparent border rounded text-center"
                        type="number"
                        value={roomItemValue?.count}
                        min={0}
                        onChange={(event) =>
                          handleRoomsCountChange(event, item)
                        }
                      />
                    </span>
                  </div>
                  <div className="col-4 d-flex alig-items-center justify-content-end p-0">
                    <span className="col-8 d-flex align-items-center justify-content-end p-0 text-nowrap">
                      {intl.formatMessage({ id: 'booking.extrabed' })}
                    </span>
                    <span className="col-4 p-0">
                      <Conditional checkRender={!!item?.extra_capacity}>
                        <Checkbox
                          name={`hasExtraBeds-${item?.id}`}
                          id={`hasExtraBeds-${item?.id}`}
                          inputClassName="text-primary m-0 text-nowrap"
                          checked={roomItemValue?.extraBeds}
                          onChange={() => handleExtraBedsCheck(item)}
                        />
                      </Conditional>
                    </span>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

RoomTypeMultiSelect.propTypes = {
  isHotelChanged: PropTypes?.bool,
  intl: PropTypes.object,
  language: PropTypes.object,
  hotel: PropTypes.object,
  value: PropTypes.object,
  onSelectRoom: PropTypes.func,
  setIsHotelChanged: PropTypes?.func,
};

export default RoomTypeMultiSelect;
